module.exports = __webpack_public_path__ + "img/howtouse01.a556eece.jpg";